import Vue from 'vue';
import Router from 'vue-router';
import 'nprogress/nprogress.css';
// eslint-disable-next-line import/no-cycle
import Home from '../views/Home.vue';

Vue.use(Router);

const index = () => import('../views/layout');

// 静态路由
export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/Login'),
  },
  {
    path: '/index',
    name: 'index',
    component: index,
  },
  {
    path: '/entryRegistrationFormH5',
    name: 'entryRegistrationFormH5',
    component: () => import('../views/personnelAdmin/entry/entryRegistrationFormH5'),
  },
  {
    path: '/',
    name: '',
    redirect: '/index',
  },
  {
    path: '/page404',
    name: 'page404',
    component: () => import('../views/login/404'),
  },
  {
    path: '/staffDetail',
    name: 'staffDetail',
    component: () => import('../views/personnelAdmin/staff/staffDetail'),
  },
  {
    path: '/InterviewRegistrationForm',
    name: 'InterviewRegistrationForm',
    component: () => import('../views/recruiteManage/InterviewRegistrationForm'),
  },
  {
    path: '/sendEmployNoticeForm',
    name: 'sendEmployNoticeForm',
    component: () => import('../views/recruiteManage/sendEmployNoticeForm'),
  },

  // {
  //   path: '*',
  //   name: 'page404',
  //   component: () => import('../views/login/404'),
  // },
];


export const createRouter = () => new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constantRouterMap,
});
const router = createRouter();

export default router;

// 未经权限处理的路由表
export const asyncRouterMap = [
  {
    path: '/homepage',
    name: 'homepage',
    component: index,
    meta: { title: '首页', code: '1401' },
    redirect: 'home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: Home,
        meta: { title: '首页' },
      },
    ],
  },
  {
    path: '/organizeAdmin',
    name: 'organizeAdmin',
    component: index,
    meta: { title: '组织管理', code: '1402' },
    redirect: '/department',
    children: [
      {
        path: 'department',
        name: 'department',
        component: () => import('@/views/organizeAdmin/department.vue'),
        meta: { title: '部门管理', code: '140201' },
      },
      {
        path: 'rank',
        name: 'rank',
        component: () => import('@/views/organizeAdmin/rank.vue'),
        meta: { title: '职级管理', code: '140205' },
      },
      {
        path: 'guard',
        name: 'guard',
        component: () => import('@/views/organizeAdmin/guard.vue'),
        meta: { title: '岗位管理', code: '140202' },
      },
      {
        path: 'positionLevel',
        name: 'positionLevel',
        component: () => import('@/views/organizeAdmin/positionLevel.vue'),
        meta: { title: '职等管理', code: '140204' },
      },
      {
        path: 'job',
        name: 'job',
        component: () => import('@/views/organizeAdmin/job.vue'),
        meta: { title: '职位管理', code: '140203' },
      },
    ],
  },
  {
    path: '/personnelAdmin',
    name: 'personnelAdmin',
    component: index,
    meta: { title: '人事管理', code: '1403' },
    children: [
      {
        path: 'entry',
        name: 'entry',
        component: () => import('../views/personnelAdmin/entry'),
        meta: { title: '入职管理', code: '140301' },
      },
      {
        path: 'staff',
        name: 'staff',
        component: () => import('../views/personnelAdmin/staff'),
        meta: { title: '员工管理', code: '140304' },
      },
      {
        path: 'turn',
        name: 'turn',
        component: () => import('../views/personnelAdmin/turn'),
        meta: { title: '异动管理', code: '140302' },
      },
      {
        path: 'dimission',
        name: 'dimission',
        component: () => import('../views/personnelAdmin/dimission'),
        meta: { title: '离职管理', code: '140303' },
      },
    ],
  },
  {
    path: '/attendanceAdmin',
    name: 'attendanceAdmin',
    component: index,
    meta: { title: '考勤管理', code: '1404' },
    children: [
      {
        path: 'attendanceSettings',
        name: 'attendanceSettings',
        component: () => import('../views/attendanceAdmin/attendanceSettings'),
        meta: {
          title: '考勤设置', code: '140401',
        },
      },
      {
        path: 'annualLeaveManage',
        name: 'annualLeaveManage',
        component: () => import('../views/attendanceAdmin/annualLeaveManage'),
        meta: {
          title: '年假管理', code: '140402',
        },
      },
      {
        path: 'workCalendar',
        name: 'workCalendar',
        component: () => import('../views/attendanceAdmin/workCalendar.vue'),
        meta: {
          title: '工作日历', code: '140403',
        },
      },
      {
        path: 'attendanceScheduling',
        name: 'attendanceScheduling',
        component: () => import('../views/attendanceAdmin/attendanceScheduling'),
        meta: {
          title: '考勤排班', code: '140404',
        },
      },
      {
        path: 'attendanceRecord',
        name: 'attendanceRecord',
        component: () => import('../views/attendanceAdmin/attendanceRecord'),
        meta: {
          title: '考勤记录', code: '140405',
        },
      },
      {
        path: 'daily',
        name: 'daily',
        component: () => import('../views/attendanceAdmin/daily.vue'),
        meta: {
          title: '考勤日报', code: '140409',
        },
      },
      {
        path: 'leaveRecord',
        name: 'leaveRecord',
        component: () => import('../views/attendanceAdmin/leaveRecord.vue'),
        meta: {
          title: '请假记录', code: '140406',
        },
      },
      {
        path: 'attendanceStatistics',
        name: 'attendanceStatistics',
        component: () => import('../views/attendanceAdmin/attendanceStatistics.vue'),
        meta: {
          title: '考勤统计', code: '140407',
        },
      },
      {
        path: 'replaceEquipmentApproval',
        name: 'replaceEquipmentApproval',
        component: () => import('../views/attendanceAdmin/replaceEquipmentApproval.vue'),
        meta: {
          title: '更换设备审批', code: '140408',
        },
      },
    ],
  },
  {
    path: '/authorityAdmin',
    name: 'authorityAdmin',
    component: index,
    meta: { title: '权限管理', code: '1405' },
    children: [
      {
        path: 'menus',
        name: 'menus',
        component: () => import('../views/authorityAdmin/menus.vue'),
        meta: {
          title: '菜单管理', code: '140501',
        },
      },
      {
        path: 'data',
        name: 'data',
        component: () => import('../views/authorityAdmin/data.vue'),
        meta: {
          title: '数据管理', code: '140502',
        },
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('../views/authorityAdmin/role'),
        meta: { title: '角色管理', code: '140503' },
      },
      {
        path: 'user',
        name: 'user',
        component: () => import('../views/authorityAdmin/user'),
        meta: { title: '用户管理', code: '140504' },
      },
    ],
  },
  {
    path: '/recruiteManage',
    name: 'recruiteManage',
    component: index,
    meta: { title: '招聘综合管理', code: '1406' },
    children: [
      {
        path: 'RecruiteApplicate',
        name: 'RecruiteApplicate',
        component: () => import('../views/recruiteManage/RecruiteApplicate.vue'),
        meta: {
          title: '招聘申请', code: '140601',
        },
      },
      {
        path: 'RecruiteApproval',
        name: 'RecruiteApproval',
        component: () => import('../views/recruiteManage/RecruiteApproval.vue'),
        meta: {
          title: '招聘审批', code: '140602',
        },
      },
      {
        path: 'InterviewManage',
        name: 'InterviewManage',
        component: () => import('../views/recruiteManage/InterviewManage.vue'),
        meta: {
          title: '面试管理', code: '140603',
        },
      },
    ],
  },
  {
    path: '/contractManage',
    name: 'contractManage',
    component: index,
    meta: { title: '合同管理', code: '1407' },
    children: [
      {
        path: 'contractTemplateManage',
        name: 'contractTemplateManage',
        component: () => import('../views/contractManage/contractTemplateManage.vue'),
        meta: {
          title: '合同模板管理', code: '140701',
        },
      },
      {
        path: 'contractQuery',
        name: 'contractQuery',
        component: () => import('../views/contractManage/contractQuery.vue'),
        meta: {
          title: '合同查询', code: '140702',
        },
      },
    ],
  },
];
